export default __webpack_public_path__ + "static/lisboa-15may-068-665f262e9d7b0-d64596d71fc552e8b974713debe3e5aa.webp";